<template>
  <div class="card-header">
    <div class="flex items-center gap-3 flex-wrap">
      <h3 class="card-header-title">{{ title }}</h3>
      <slot name="badge"></slot>
    </div>
    <div class="card-header-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
